import $ from "jquery";
import { smoothscroll } from "../utils/smoothscroll";
import { debounce, getHeaderHeight } from "../utils/functions";
jQuery.fn.reverse = Array.prototype.reverse;

const $window = $(window);
const $body = $(".page__body");
const $areaEl = $(".area-insight");
const $scrollTop = $(".footer__scrolltop");

$(function () {
  if ($areaEl.length > 0) {
    $areaEl.each(function () {
      areaInsight($(this));
    });
  }
});

const areaInsight = (areaEl) => {
  areaEl.on("click", ".area-insight__field:visible", function () {
    highlightField(areaEl, $(this));
  });

  bindMainEvents(areaEl);
  $window.on(
    "resize",
    debounce(function () {
      bindMainEvents(areaEl);
    })
  );

  $scrollTop.on("click", function () {
    highlightField(areaEl, areaEl.find(".area-insight__field:visible").first());
  });
};

const bindMainEvents = (areaEl) => {
  highlightBorder(areaEl);
  unbindMainEvents(areaEl);

  if (areaEl.find(".area-insight__field:visible").hasClass("desktop")) {
    // if (areaEl.outerHeight() <= $window.height() - getHeaderHeight()) {
    //     bindStaticScroll(areaEl);
    // } else {
    areaEl.on(
      "mouseover.smallScreen",
      ".area-insight__field:visible",
      function () {
        highlightField(areaEl, $(this));
      }
    );
    // }
  }
};

const unbindMainEvents = (areaEl) => {
  unbindStaticScroll();
  areaEl.off("mouseover.smallScreen");
  unbindHighlight();
  enableScroll();
};

const highlightBorder = (areaEl) => {
  if (areaEl.position().top > getHeaderHeight()) {
    highlightField(areaEl, areaEl.find(".area-insight__field:visible").first());
  } else {
    highlightField(areaEl, areaEl.find(".area-insight__field:visible").last());
  }
};

const bindStaticScroll = (areaEl) => {
  unbindStaticScroll();
  $window.on("scroll:down", { areaEl: areaEl, up: false }, staticScroll);
  $window.on("scroll:up", { areaEl: areaEl, up: true }, staticScroll);
};

const unbindStaticScroll = () => {
  $window.off("scroll:down", staticScroll);
  $window.off("scroll:up", staticScroll);
};

function staticScroll(event) {
  const areaEl = event.data.areaEl;
  const up = event.data.up;

  let $lastField;
  if (up === true) {
    $lastField = areaEl.find(".area-insight__field:visible").first();
  } else {
    $lastField = areaEl.find(".area-insight__field:visible").last();
  }

  if (!$lastField.hasClass("active")) {
    if (
      (up === true && areaEl.position().top >= getHeaderHeight()) ||
      (up === false && areaEl.position().top <= getHeaderHeight())
    ) {
      doStaticScroll(areaEl);
    }
  }
}

const doStaticScroll = (areaEl) => {
  unbindStaticScroll();
  disableScroll();
  smoothscroll(areaEl, "header", 0).then(() => bindHighlight(areaEl));
};

const bindHighlight = (areaEl) => {
  unbindHighlight();
  $window.on(
    "wheel:down.highlightNext",
    { areaEl: areaEl },
    debounce(highlightNext, false, 80)
  );
  $window.on(
    "wheel:up.highlightPrev",
    { areaEl: areaEl },
    debounce(highlightPrev, false, 80)
  );
};

const unbindHighlight = () => {
  $window.off("wheel:down.highlightNext");
  $window.off("wheel:up.highlightPrev");
};

function highlightNext(event) {
  const areaEl = event.data.areaEl;
  const $fields = areaEl.find(".area-insight__field:visible");
  findFieldForHighlight(areaEl, $fields);
}

function highlightPrev(event) {
  const areaEl = event.data.areaEl;
  const $fields = areaEl.find(".area-insight__field:visible").reverse();
  findFieldForHighlight(areaEl, $fields);
}

const findFieldForHighlight = (areaEl, fields) => {
  fields.each(function (i) {
    if (i === fields.length - 1) {
      unbindHighlight();
      enableScroll();
      bindStaticScroll(areaEl);
      return false;
    }

    if ($(this).hasClass("active")) {
      highlightField(areaEl, $(fields.get(i + 1)));
      return false;
    }
  });
};

const highlightField = (areaEl, el) => {
  areaEl.find(".area-insight__field.active").removeClass("active");
  areaEl.find(".area-insight__right.active").removeClass("active");
  el.addClass("active");

  const detailId = el.data("id");
  if (detailId !== undefined) {
    areaEl.find(detailId).addClass("active");
  }
};

const disableScroll = () => $body.addClass("scroll-lock");
const enableScroll = () => $body.removeClass("scroll-lock");
